define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"dojo/when"
], function(array, lang, when) {

	// reference dojo/store/util/QueryResults - just one minor change below to make it work

	var _QueryResults = function(results) {
		if (!results) {
			return results;
		}
		if (results.then) {
			results = lang.delegate(results);
		}
		function addIterativeMethod(method) {
			if (!results[method]) {
				results[method] = function() {
					var args = arguments;
					return when(results, function(results) {
						Array.prototype.unshift.call(args, results);
						return _QueryResults(array[method].apply(array, args));
					});
				};
			}
		}
		addIterativeMethod("forEach");
		addIterativeMethod("filter");
		addIterativeMethod("map");
		if (!results.total) {
			results.total = when(results, function(results) {
				// change to look for results.total before defaulting to results.length;
				// results.length will always be set to the query count rather than the true total
				return results.total || results.length;
			});
		}
		return results;
	};

	return _QueryResults;
});